'use strict';

module.exports = '3.21.1';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/version.js
// module id = 417
// module chunks = 0